var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      attrs: { "element-loading-text": "保存中..." }
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("代理下单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.servcOrder, rules: _vm.checkRetails }
        },
        [
          _c("div", { staticClass: "block-container" }, [
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("选择合同")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form" }, [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("选择合同")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcOrder.contractName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "contractName", $$v)
                        },
                        expression: "servcOrder.contractName"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("合同编号")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcOrder.contractOriginalNo,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "contractOriginalNo", $$v)
                        },
                        expression: "servcOrder.contractOriginalNo"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.servcOrder.contractId != null &&
              _vm.trackPhaseList != null &&
              _vm.trackPhaseList.length > 0
                ? _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("选择合同阶段")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "fl",
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.trackPhaseId,
                              callback: function($$v) {
                                _vm.trackPhaseId = $$v
                              },
                              expression: "trackPhaseId"
                            }
                          },
                          _vm._l(_vm.trackPhaseList, function(trackPhase) {
                            return _c("el-option", {
                              key: trackPhase.id,
                              attrs: {
                                label: trackPhase.name,
                                value: trackPhase.id
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("添加服务")])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "custom-tbl" }, [
              _c("thead", { staticClass: "head" }, [
                _c("tr", { staticClass: "row" }, [
                  _c(
                    "th",
                    { attrs: { width: "50" } },
                    [
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            _vm.selectAll()
                          }
                        },
                        model: {
                          value: _vm.allChecked,
                          callback: function($$v) {
                            _vm.allChecked = $$v
                          },
                          expression: "allChecked"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { width: "" }
                    },
                    [_vm._v("名称")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("质保期(天)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("上门费(元)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("服务费(元)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { width: "" }
                    },
                    [_vm._v("固定规格说明")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "110" }
                    },
                    [_vm._v("响应时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "110" }
                    },
                    [_vm._v("到达时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "110" }
                    },
                    [_vm._v("完成时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("服务次数")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("已服务次数")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { width: "60" }
                    },
                    [_vm._v("操作")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                { staticClass: "body" },
                [
                  _vm._l(_vm.servcOrder.servOrderItemList, function(
                    servOrderItem
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        [
                          _c("el-checkbox", {
                            on: {
                              change: function($event) {
                                _vm.selectMku(servOrderItem)
                              }
                            },
                            model: {
                              value: servOrderItem.checked,
                              callback: function($$v) {
                                _vm.$set(servOrderItem, "checked", $$v)
                              },
                              expression: "servOrderItem.checked"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(servOrderItem.name))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.wrntPeriod))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(
                          _vm._s(
                            parseFloat(servOrderItem.toDoorFee || 0).toFixed(2)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(
                          _vm._s(
                            parseFloat(servOrderItem.generallFee || 0).toFixed(
                              2
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(_vm._s(servOrderItem.msu.fixedSpec))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.yqRspTimeMi))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.yqArriveTimeMi))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.yqRepairedTimeMi))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.quantity || 0))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(servOrderItem.usedQuantity))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "left" } }, [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeMsu(servOrderItem.ssuId)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      { staticClass: "display-none", attrs: { colspan: "8" } },
                      [
                        _c("div", { staticClass: "no-data" }, [
                          _c("i", {
                            staticClass: "icon iconfont icon-zanwushuju mr10",
                            staticStyle: {
                              "font-size": "58px",
                              "vertical-align": "middle"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {}, [_vm._v("暂无数据 . . .")])
                        ])
                      ]
                    )
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed" }, [
              _c("span", [_vm._v("选择服务商")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form" }, [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("服务商名称")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcOrder.sellerName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "sellerName", $$v)
                        },
                        expression: "servcOrder.sellerName"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [_c("label")]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("选择零售商")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "peerMerchantName" } },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x bottom-line",
                          attrs: { disabled: true },
                          model: {
                            value: _vm.servcOrder.buyerName,
                            callback: function($$v) {
                              _vm.$set(_vm.servcOrder, "buyerName", $$v)
                            },
                            expression: "servcOrder.buyerName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("零售商机构")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "buyerShopName" } },
                      [
                        _c("el-input", {
                          staticClass: "width-1-5x bottom-line",
                          attrs: { disabled: true },
                          model: {
                            value: _vm.servcOrder.buyerShopName,
                            callback: function($$v) {
                              _vm.$set(_vm.servcOrder, "buyerShopName", $$v)
                            },
                            expression: "servcOrder.buyerShopName"
                          }
                        }),
                        _vm._v(" "),
                        _vm.isClick
                          ? _c("i", {
                              staticClass:
                                "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                              on: { click: _vm.selectRetailOrg }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("机构联系人")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      model: {
                        value: _vm.servcOrder.buyerShopContactName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "buyerShopContactName", $$v)
                        },
                        expression: "servcOrder.buyerShopContactName"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("机构电话")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x ",
                      model: {
                        value: _vm.servcOrder.buyerShopContactTel,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "buyerShopContactTel", $$v)
                        },
                        expression: "servcOrder.buyerShopContactTel"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("预约时间")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-date-picker", {
                      staticClass: "width-1-5x",
                      attrs: {
                        type: "datetime",
                        placeholder: "选择日期",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.planTime,
                        callback: function($$v) {
                          _vm.planTime = $$v
                        },
                        expression: "planTime"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("交易总金额")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.servcOrder.totalAmount,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "totalAmount", $$v)
                        },
                        expression: "servcOrder.totalAmount"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", {}, [_vm._v("故障描述")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "故障描述最大长度120个字",
                        maxlength: 120,
                        minlength: 10
                      },
                      model: {
                        value: _vm.servcOrder.troubleDesc,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "troubleDesc", $$v)
                        },
                        expression: "servcOrder.troubleDesc"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", {}, [_vm._v("附言")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "附言最大长度120个字",
                        maxlength: 120,
                        minlength: 10
                      },
                      model: {
                        value: _vm.servcOrder.postscript,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "postscript", $$v)
                        },
                        expression: "servcOrder.postscript"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          { staticClass: "swb-btn", on: { click: _vm.submitServcOrder } },
          [_vm._v("提交")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-757a89c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757a89c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/ServcOrderCreate.vue
// module id = 2873
// module chunks = 0